import { useNavigate } from "react-router-dom";
import { MoreVertical, Star, Paperclip, Bell } from "lucide-react";
import { playTap } from "@/lib/sounds";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { CategoryIcon } from "@/components/CategoryIcon";
import { absUrl } from "@/lib/api";
import { relativeDate } from "@/lib/format";

export function MemoryCard({ memory, onFavorite, onArchive, onDelete, compact = false }) {
  const navigate = useNavigate();
  const img = memory.attachments?.find((a) => a.content_type?.startsWith("image/"));
  return (
    <div className="ga-card flex items-center gap-3 p-3 transition-transform active:scale-[0.99]" data-testid={`memory-card-${memory.id}`}>
      <button onClick={() => navigate(`/memorias/${memory.id}`)} className="flex min-w-0 flex-1 items-center gap-3 text-left" data-testid={`memory-card-open-${memory.id}`}>
        {img ? (
          <img src={absUrl(img.url)} alt="" className="h-11 w-11 shrink-0 rounded-2xl object-cover" />
        ) : (
          <CategoryIcon category={memory.category} />
        )}
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5">
            <h3 className="truncate text-sm font-semibold">{memory.title}</h3>
            {memory.favorite && <Star size={13} className="shrink-0 fill-amber-400 text-amber-400" />}
          </div>
          <p className="ga-muted truncate text-xs">{memory.summary}</p>
          {!compact && (
            <div className="ga-muted mt-1 flex items-center gap-2 text-[11px]">
              <span>{relativeDate(memory.created_at)}</span>
              <span>•</span>
              <span>{memory.category}</span>
              {memory.attachments?.length > 0 && <Paperclip size={11} />}
              {memory.reminders?.some((r) => r.status === "pending") && <Bell size={11} />}
              {memory.loan?.is_loan && memory.loan.status !== "devolvido" && <span className="rounded-full bg-orange-100 px-1.5 text-orange-600 dark:bg-orange-900/40">emprestado</span>}
            </div>
          )}
        </div>
      </button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="ga-muted flex h-9 w-9 items-center justify-center rounded-full" aria-label="Opções" data-testid={`memory-card-menu-${memory.id}`}>
            <MoreVertical size={18} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="rounded-xl">
          <DropdownMenuItem onClick={() => navigate(`/memorias/${memory.id}`)}>Abrir</DropdownMenuItem>
          {onFavorite && <DropdownMenuItem onClick={() => { playTap(); onFavorite(memory); }}>{memory.favorite ? "Remover favorito" : "Favoritar"}</DropdownMenuItem>}
          {onArchive && <DropdownMenuItem onClick={() => onArchive(memory)}>{memory.archived ? "Desarquivar" : "Arquivar"}</DropdownMenuItem>}
          {onDelete && <DropdownMenuItem className="text-red-500" onClick={() => onDelete(memory)}>Excluir</DropdownMenuItem>}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
